import {Explained} from './Info';
import {
  formatAverageRating,
  formatCount,
  formatCoverage,
  formatDuration,
} from './performanceUtils';
import styles from './performance.module.scss';

const hasValue = value => value !== null && value !== undefined;

const Compare = ({label, term, mine, team, teamNote}) => (
  <div className={styles.benchmark}>
    <span className={styles.bigLabel}>
      <Explained text={term}>{label}</Explained>
    </span>
    <span className={styles.benchmarkValue}>{mine}</span>
    <span className={styles.smallNote}>
      Team {team}
      {teamNote ? ` · ${teamNote}` : ''}
    </span>
  </div>
);

/**
 * This agent against the support team, for the same filters. Every team
 * figure comes from the server (weighted, never an average of averages), and
 * no other agent is named.
 */
export const Benchmarks = ({metrics, benchmarks}) => {
  if (!benchmarks) return null;
  const rank = hasValue(benchmarks.resolvedRank)
    ? `#${benchmarks.resolvedRank} of ${formatCount(benchmarks.agentCount)}`
    : 'Not ranked';
  return (
    <div className={styles.benchmarks}>
      <Compare
        label="Resolved"
        term="Tickets this agent resolved, against the average per agent on the team. Agents with the same count share a rank."
        mine={formatCount(metrics?.resolved)}
        team={`average ${Number(benchmarks.averageResolved || 0).toFixed(1)}`}
        teamNote={rank}
      />
      <Compare
        label="Share of team closures"
        term="This agent's resolved tickets as a share of everything the team resolved."
        mine={formatCoverage(benchmarks.resolvedShare ?? 0)}
        team={`${formatCount(benchmarks.resolvedCount)} resolved`}
      />
      <Compare
        label="Rating"
        term="This agent's average customer rating against the whole team's, each with how many ratings it rests on."
        mine={
          <>
            {formatAverageRating(metrics?.averageRating)}
            <span className={styles.smallNote}>
              {' '}
              {formatCount(metrics?.ratingCount || 0)} rated ·{' '}
              {formatCoverage(metrics?.ratingCoverage ?? 0)}
            </span>
          </>
        }
        team={formatAverageRating(benchmarks.averageRating)}
        teamNote={`${formatCount(
          benchmarks.ratingCount || 0,
        )} rated · ${formatCoverage(benchmarks.ratingCoverage ?? 0)}`}
      />
      <Compare
        label="Resolution time"
        term="Average calendar time from a ticket being opened to it being resolved, this agent against the team."
        mine={formatDuration(metrics?.averageCustomerWaitSeconds)}
        team={formatDuration(benchmarks.averageCustomerWaitSeconds)}
        teamNote={`from ${formatCount(
          benchmarks.customerTimeCount || 0,
        )} tickets`}
      />
    </div>
  );
};
